(function () {
  'use strict';

  // Nail polish shade -> hex, sourced from each polish's color metaobject.
  var COLOR_MAP = {
    '02 Sunset Boulevard': '#9eb2cf',
    '04 Tabou': '#f72c2c',
    '05 Sweet Life': '#ef5fb9',
    '06 Darling Nikki': '#f928b4',
    '11 Pearl of a Girl': '#ececec',
    '13 Kitten': '#ec2475',
    '14 Hussy': '#fc1010',
    '15 Santa Sangre': '#9c0a0a',
    '17 Deep Sea': '#0c1a53',
    '18 Soft Focus': '#cbd4f9',
    '20 Retrograde': '#6f7b53',
    '22 Diabolique': '#510404',
    '23 Ingenue': '#e6cea6',
    '24 Tanlines': '#d4aa78',
    '28 Swimming Pool': '#46c4cc',
    '29 Scarab': '#1e7854',
    '33 Space Cadet': '#0a0859',
    '36 Moon Rock': '#ede0e0',
    '39 Voyeur': '#fcd7e4',
    '40 Nymph': '#f9dcdc',
    '41 Terra': '#f97763',
    '42 Cavalier': '#f1b96a',
    '45 Belladonna': '#c386fc',
    '47 Cat Lady': '#8672a1',
    '49 Tandoori': '#f46c2d',
    '51 Scorpio Rising': '#781414',
    '53 Daisy Chain': '#f9f2bc',
    '55 Bop Bop!': '#abecdf',
    '56 Jolly Bean Green': '#6ff9b5',
    '57 Blue Jean Baby': '#0b88ce',
    '63 Mimosa Mami': '#fc8f5e',
    '64 Golden Hour': '#cf4324',
    "66 90's Baby": '#b9f0f7',
    '67 Bootleg': '#d6fcb3',
    '68 BAPS': '#ffc769',
    '71 Forbidden Fruit': '#f242a1',
    '72 Versayce': '#fa823e',
    '73 Brownie Points': '#874848',
    '74 Night Drive': '#05369c',
    '75 Rich Bitch': '#f7e1e1',
    '76 Bam Bam': '#bbebad',
    '77 Clementine': '#ff651e',
    '78 Sashimi': '#f73460',
    '79 Oyster': '#e6e4e4',
    '80 Caviar': '#f2d5ab',
    '81 Laura Palmer': '#fcb77f',
    '82 Bonsai': '#56a35e',
    '83 Chocolate Cherry': '#9f2424',
    '85 Coconut': '#e6e4de'
  };

  function swatchClass(name) {
    return COLOR_MAP[name] ? 'pcs-swatch' : 'pcs-swatch pcs-swatch--none';
  }

  function buildSwatchSpan(name) {
    var span = document.createElement('span');
    span.className = swatchClass(name);
    var hex = COLOR_MAP[name];
    if (hex) span.style.background = hex;
    span.setAttribute('aria-hidden', 'true');
    return span;
  }

  function closeAllPanels(except) {
    document.querySelectorAll('.pcs-panel.is-open').forEach(function (panel) {
      if (panel === except) return;
      panel.classList.remove('is-open');
      var trigger = panel.previousElementSibling;
      if (trigger && trigger.classList.contains('pcs-trigger')) {
        trigger.setAttribute('aria-expanded', 'false');
      }
    });
  }

  function enhanceSelect(select) {
    if (select.dataset.pcsEnhanced) return;
    select.dataset.pcsEnhanced = 'true';

    var wrap = document.createElement('div');
    wrap.className = 'pcs-wrap';
    select.parentNode.insertBefore(wrap, select);
    wrap.appendChild(select);
    select.classList.add('pcs-native-select');
    select.setAttribute('tabindex', '-1');
    select.setAttribute('aria-hidden', 'true');

    var trigger = document.createElement('div');
    trigger.className = 'pcs-trigger';
    trigger.setAttribute('role', 'button');
    trigger.setAttribute('tabindex', '0');
    trigger.setAttribute('aria-haspopup', 'listbox');
    trigger.setAttribute('aria-expanded', 'false');

    var triggerLabel = document.createElement('span');
    triggerLabel.className = 'pcs-trigger-label';

    var triggerText = document.createElement('span');
    triggerText.className = 'pcs-text';

    var caret = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    caret.setAttribute('class', 'pcs-caret');
    caret.setAttribute('width', '10');
    caret.setAttribute('height', '6');
    caret.setAttribute('viewBox', '0 0 10 6');
    caret.setAttribute('fill', 'none');
    caret.innerHTML = '<path d="M0.699219 0.700195L4.69922 4.7002L8.69922 0.700195" stroke="#1C2B59" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/>';

    triggerLabel.appendChild(triggerText);
    trigger.appendChild(triggerLabel);
    trigger.appendChild(caret);

    var panel = document.createElement('div');
    panel.className = 'pcs-panel';
    panel.setAttribute('role', 'listbox');

    var optionEls = [];
    Array.prototype.forEach.call(select.options, function (opt) {
      if (opt.disabled || opt.value === '') return;

      var row = document.createElement('div');
      row.className = 'pcs-option';
      row.setAttribute('role', 'option');
      row.setAttribute('tabindex', '-1');
      row.dataset.value = opt.value;

      row.appendChild(buildSwatchSpan(opt.value));

      var text = document.createElement('span');
      text.textContent = opt.textContent.trim();
      row.appendChild(text);

      row.addEventListener('click', function () {
        selectOption(opt.value);
      });

      panel.appendChild(row);
      optionEls.push(row);
    });

    function updateTriggerDisplay() {
      var current = select.options[select.selectedIndex];
      var name = current ? current.value : '';
      triggerText.textContent = current ? current.textContent.trim() : '';

      var existingSwatch = triggerLabel.querySelector('.pcs-swatch');
      if (existingSwatch) existingSwatch.remove();
      if (name) triggerLabel.insertBefore(buildSwatchSpan(name), triggerText);

      optionEls.forEach(function (row) {
        var isSelected = row.dataset.value === name;
        row.setAttribute('aria-selected', isSelected ? 'true' : 'false');
        row.classList.toggle('is-active', isSelected);
      });
    }

    function selectOption(value) {
      select.value = value;
      select.dispatchEvent(new Event('input', { bubbles: true }));
      select.dispatchEvent(new Event('change', { bubbles: true }));
      updateTriggerDisplay();
      closePanel();
      trigger.focus();
    }

    function openPanel() {
      closeAllPanels(panel);
      panel.classList.add('is-open');
      trigger.setAttribute('aria-expanded', 'true');
      var active = panel.querySelector('.pcs-option.is-active') || optionEls[0];
      if (active) active.focus();
    }

    function closePanel() {
      panel.classList.remove('is-open');
      trigger.setAttribute('aria-expanded', 'false');
    }

    function togglePanel() {
      if (panel.classList.contains('is-open')) {
        closePanel();
      } else {
        openPanel();
      }
    }

    trigger.addEventListener('click', togglePanel);
    trigger.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ' || e.key === 'ArrowDown') {
        e.preventDefault();
        openPanel();
      } else if (e.key === 'Escape') {
        closePanel();
      }
    });

    optionEls.forEach(function (row, i) {
      row.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowDown') {
          e.preventDefault();
          (optionEls[i + 1] || optionEls[0]).focus();
        } else if (e.key === 'ArrowUp') {
          e.preventDefault();
          (optionEls[i - 1] || optionEls[optionEls.length - 1]).focus();
        } else if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          selectOption(row.dataset.value);
        } else if (e.key === 'Escape') {
          e.preventDefault();
          closePanel();
          trigger.focus();
        }
      });
    });

    select.addEventListener('change', updateTriggerDisplay);

    wrap.appendChild(trigger);
    wrap.appendChild(panel);
    updateTriggerDisplay();
  }

  function scan() {
    document
      .querySelectorAll('select[name^="properties[Pick Color"]')
      .forEach(enhanceSelect);
  }

  document.addEventListener('click', function (e) {
    if (!e.target.closest('.pcs-wrap')) closeAllPanels();
  });

  document.addEventListener('DOMContentLoaded', scan);
  scan();

  var observer = new MutationObserver(function () {
    scan();
  });
  observer.observe(document.body, { childList: true, subtree: true });
})();
